// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.encounter.workflow.device.MappedTestFieldRequest */
/* istanbul ignore next */
@GandalfModel
export class MappedTestFieldRequest extends GandalfModelBase {

	@GandalfLabel('Field Master ID')
	@GandalfValidator({ notNull: { message: 'Field Master ID is required' } })
	@GandalfValidator({ sizeString: { message: 'Field Master ID must be between 1 and 20 characters', minLength: 1, maxLength: 20 } })
	@GandalfProperty({ designType: String, isRequired: true })
	fieldConfigurationMasterIdentifier!: string;

	@GandalfLabel('Value')
	@GandalfValidator({ sizeString: { min: 0, max: 65535, message: 'Value cannot be longer than 65535 characters' } })
	@GandalfProperty({ designType: String })
	value!: string;

}
